import { TextField } from '@mui/material';

type EmailInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  required: boolean;
};

export function BirthRegistryOfficeInput({
  value,
  onChange,
  required,
}: EmailInputProps) {
  return (
    <TextField
      label='Geburtsstandesamt'
      size='small'
      value={value}
      onChange={event =>
        onChange(event.target.value === '' ? null : event.target.value)
      }
      fullWidth
      type='text'
      required={required}
    />
  );
}
